import { useCallback, useMemo, useSyncExternalStore } from 'react';
import { getMediaQueryList, subscribeToMediaQuery } from './viewport';

const noop = () => {};

function useMediaQuery(query) {
    const mediaQueryList = useMemo(() => getMediaQueryList(query), [query]);
    const subscribe = useCallback(
        (onChange) => (mediaQueryList ? subscribeToMediaQuery(mediaQueryList, onChange) : noop),
        [mediaQueryList],
    );
    const getSnapshot = useCallback(() => (mediaQueryList ? mediaQueryList.matches : false), [mediaQueryList]);
    return useSyncExternalStore(subscribe, getSnapshot, () => false);
}

export default useMediaQuery;
